import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
// import { browserHistory } from 'react-router';
import Cfa1SubscriptionCheck from '../../RestAPI/Cfa1Subscription';
import PartnerCfa1SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa1Subscription';
import language from '../../../assets/languages/language';
import CommonFilter from '../../Common/CommonFilter';
import CommonDetailStatus from '../../Common/CommonDetailStatus';
import GetData from '../../RestAPI/getDataService';
// import AppRoutes from '../../config/AppRoutes';
// import ScrollUpButton from "react-scroll-up-button";

/* eslint-disable*/
class ViewAllQues2025 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allQuestion: [],
      selectedChapter: '',
      selectedReading: '',
      selectedQuestion: '',
      selectedAnswered: '',
      selectedAttempts: '',
      selectedAvgScore: '',
      selectedPassingScore: '',
      selectedLowerLimit: '',
      selectedUpperLimit: '',
      searchBy: 'chapterID',
      readings: [],
      chapters: [],
      totalQuestions: '',
      currentPage: 1,
      pageLimit: 20,
      pageNeighbours: 1,
      questionLowerLimit: 0,
      questionUpperLimit: 20,
      loader: true,
      url: new URL(window.location.href),
      subscriptionstatus: '',
      selectedmenu: 'cfa',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
    };
  }

  setSelectedChapter = e => {
    console.log('hello i am herer', this.state);
    const chapterId = e.target.value;
    this.setState({
      selectedChapter: e.target.value,
      selectedQuestion: '',
    });
    var data = {
      token: this.state.token,
      chapterId: chapterId,
    };
    GetData.callAPI(App_data.backend_api + '/exams/cfa/question-bank/reading', data).then(resp => {
      if (resp.success) {
        // console.log(resp)
        this.setState({ ValidToken: true });
        this.setState({ readings: resp.readings }, () => {
          // console.log(this.state.allQuestions)
        });
      } else {
        this.setState({ ValidToken: false });
        // console.log(resp)
      }
    });
  };

  setSelectedReading = e => {
    this.setState({ selectedReading: e.target.value, selectedQuestion: '' });
  };

  setSelectedQuestion = e => {
    this.setState({
      selectedQuestion: e.target.value,
      selectedChapter: '',
      selectedReading: '',
      selectedAnswered: '',
      selctedAttempts: '',
      selectedAvgScore: '',
      selectedPassingScore: '',
    });
  };

  setSelectedAnswered = e => {
    this.setState({ selectedAnswered: e.target.value });
  };

  setSelectedNoOfAttempts = e => {
    this.setState({ selectedAttempts: e.target.value });
  };

  setSelectedPagination = async (page, data) => {
    this.setState({
      totalPages: data.totalPages,
      pageLimit: data.pageLimit,
      // totalQuestions: data.totalQuestions,
      currentPage: page,
      loader: true,
    });
    var pageMinusOne = page - 1;
    var questionLowerLimit = pageMinusOne * 20;
    var questionUpperLimit = pageMinusOne * 20 + 20;
    this.setState(
      {
        questionLowerLimit: questionLowerLimit,
        questionUpperLimit: questionUpperLimit,
      },
      async () => {
        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
        this.setState({ idname: storage_session['idname'] });
        this.setState({ token: storage_session['token'] });
        var data = {
          token: storage_session['token'],
          idname: storage_session['idname'],
          chapter: this.state.selectedChapter,
          reading: this.state.selectedReading,
          question: this.state.selectedQuestion,
          selectedAnswered: this.state.selectedAnswered,
          selectedAttempts: this.state.selectedAttempts,
          selectedAvgScore: this.state.selectedAvgScore,
          selectedLowerLimit: this.state.selectedLowerLimit,
          selectedUpperLimit: this.state.selectedUpperLimit,
          selectedPassingScore: this.state.selectedPassingScore,
          questionLowerLimit: this.state.questionLowerLimit,
          questionUpperLimit: this.state.questionUpperLimit,
          subscriptionstatus: this.state.subscriptionstatus,
        };
        FD.callAPI(App_data.backend_api + '/question_bank_2024/detailedStats', data).then(resp => {
          if (resp.success) {
            window.scroll(0, 0);
            // console.log(resp)
            this.setState({ ValidToken: true });
            //   console.log(typeof resp.allQuestions)
            this.setState({
              allQuestion: resp.allQuestions,
              // totalQuestions: resp.totalQuestions,
              loader: false,
            });
          } else {
            this.setState({ ValidToken: false });
            //   console.log(resp)
          }
        });
      },
    );
  };

  setSelectedChangeAvgScores = e => {
    // console.log(e.target.value)
    if (e.target.value === '0') {
      // console.log('0 working')
      this.setState({
        selectedAvgScore: e.target.value,
        selectedLowerLimit: '0',
        selectedUpperLimit: '25',
      });
    } else if (e.target.value === '1') {
      // console.log('1 working')
      this.setState({
        selectedAvgScore: e.target.value,
        selectedLowerLimit: '25',
        selectedUpperLimit: '50',
      });
    } else if (e.target.value === '2') {
      // console.log('2 working')
      this.setState({
        selectedAvgScore: e.target.value,
        selectedLowerLimit: '50',
        selectedUpperLimit: '75',
      });
    } else if (e.target.value === '3') {
      // console.log('3 working')
      this.setState({
        selectedAvgScore: e.target.value,
        selectedLowerLimit: '75',
        selectedUpperLimit: '100',
      });
    }
  };

  setSelectedChangePass = e => {
    this.setState({ selectedPassingScore: e.target.value });
  };

  resetAllQuestion = () => {
    // console.log('reset all working')
    this.setState(
      {
        selectedChapter: '',
        selectedReading: '',
        selectedQuestion: '',
        selectedAnswered: '',
        selectedAttempts: '',
        selectedAvgScore: '',
        selectedPassingScore: '',
        selectedLowerLimit: '',
        selectedUpperLimit: '',
        questionLowerLimit: '0',
        questionUpperLimit: '20',
        readings: [],
        loader: true,
      },
      async () => {
        // console.log(this.state.selectedChapter)
        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
        this.setState({ idname: storage_session['idname'] });
        this.setState({ token: storage_session['token'] });
        var data = {
          token: storage_session['token'],
          idname: storage_session['idname'],
          chapter: this.state.selectedChapter,
          reading: this.state.selectedReading,
          question: this.state.selectedQuestion,
          selectedAnswered: this.state.selectedAnswered,
          selectedAttempts: this.state.selectedAttempts,
          selectedAvgScore: this.state.selectedAvgScore,
          selectedLowerLimit: this.state.selectedLowerLimit,
          selectedUpperLimit: this.state.selectedUpperLimit,
          selectedPassingScore: this.state.selectedPassingScore,
          questionLowerLimit: this.state.questionLowerLimit,
          questionUpperLimit: this.state.questionUpperLimit,
          subscriptionstatus: this.state.subscriptionstatus,
        };
        FD.callAPI(App_data.backend_api + '/question_bank_2024/detailedStats', data).then(resp => {
          if (resp.success) {
            // console.log(resp)
            this.setState({ ValidToken: true });
            //   console.log(typeof resp.allQuestions)
            this.setState({
              allQuestion: resp.allQuestions,
              loader: false,
            });
          } else {
            this.setState({ ValidToken: false });
          }
        });
        FD.callAPI(App_data.backend_api + '/question_bank_2024/detailedStatstotalCount', data).then(
          resp => {
            if (resp.success) {
              this.setState({ ValidToken: true });
              this.setState({
                totalQuestions: resp.totalQuestions,
              });
            } else {
              this.setState({ ValidToken: false });
            }
          },
        );
        GetData.callAPI(
          App_data.backend_api + '/exams/cfa/question-bank/chapter-wise-count',
          data,
        ).then(resp => {
          if (resp.success) {
            // console.log(resp)
            this.setState({ chapters: resp.data }, () => {
              // console.log(this.state.chapters)
            });
          } else {
            this.setState({ ValidToken: false });
            // console.log(resp)
          }
        });
      },
    );
  };

  resetAllChapter = () => {
    // console.log('reset all working')
    this.setState(
      {
        selectedChapter: '',
        selectedReading: '',
        selectedQuestion: '',
        selectedAnswered: '',
        selectedAttempts: '',
        selectedAvgScore: '',
        selectedPassingScore: '',
        selectedLowerLimit: '',
        selectedUpperLimit: '',
        questionLowerLimit: '0',
        questionUpperLimit: '20',
        readings: [],
        loader: true,
      },
      async () => {
        // console.log(this.state.selectedChapter)
        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
        this.setState({
          idname: storage_session['idname'],
          token: storage_session['token'],
        });
        var data = {
          token: storage_session['token'],
          idname: storage_session['idname'],
          chapter: this.state.selectedChapter,
          reading: this.state.selectedReading,
          question: this.state.selectedQuestion,
          selectedAnswered: this.state.selectedAnswered,
          selectedAttempts: this.state.selectedAttempts,
          selectedAvgScore: this.state.selectedAvgScore,
          selectedLowerLimit: this.state.selectedLowerLimit,
          selectedUpperLimit: this.state.selectedUpperLimit,
          selectedPassingScore: this.state.selectedPassingScore,
          questionLowerLimit: this.state.questionLowerLimit,
          questionUpperLimit: this.state.questionUpperLimit,
          subscriptionstatus: this.state.subscriptionstatus,
        };
        await FD.callAPI(App_data.backend_api + '/question_bank_2024/detailedStats', data).then(
          resp => {
            if (resp.success) {
              // console.log(resp)
              this.setState({ ValidToken: true });
              //   console.log(typeof resp.allQuestions)
              this.setState({
                allQuestion: resp.allQuestions,
                loader: false,
              });
            } else {
              this.setState({ ValidToken: false });
              // console.log(resp)
            }
          },
        );
        FD.callAPI(App_data.backend_api + '/question_bank_2024/detailedStatstotalCount', data).then(
          resp => {
            if (resp.success) {
              this.setState({ ValidToken: true });
              this.setState({
                totalQuestions: resp.totalQuestions,
              });
            } else {
              this.setState({ ValidToken: false });
            }
          },
        );
        await GetData.callAPI(
          App_data.backend_api + '/exams/cfa/question-bank/chapter-wise-count',
          data,
        ).then(resp => {
          if (resp.success) {
            // console.log(resp)
            this.setState({ chapters: resp.data }, () => {
              // console.log(this.state.chapters)
            });
          } else {
            this.setState({ ValidToken: false });
            // console.log(resp)
          }
        });
      },
    );
  };

  async _filerQuestionsByChapter() {
    this.setState({ loader: true });
    // console.log(this.state.searchBy)
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      chapter: this.state.selectedChapter,
      reading: this.state.selectedReading,
      question: this.state.selectedQuestion,
      selectedAnswered: this.state.selectedAnswered,
      selectedAttempts: this.state.selectedAttempts,
      selectedAvgScore: this.state.selectedAvgScore,
      selectedLowerLimit: this.state.selectedLowerLimit,
      selectedUpperLimit: this.state.selectedUpperLimit,
      selectedPassingScore: this.state.selectedPassingScore,
      questionLowerLimit: 0,
      questionUpperLimit: 20,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    FD.callAPI(App_data.backend_api + '/question_bank_2024/detailedStats', data).then(resp => {
      if (resp.success) {
        // console.log(resp)
        this.setState({ ValidToken: true });
        this.setState({
          currentPage: 1,
          questionLowerLimit: 0,
          questionUpperLimit: 20,
          allQuestion: resp.allQuestions,
          loader: false,
        });
      } else {
        this.setState({ ValidToken: false });
      }
    });
    FD.callAPI(App_data.backend_api + '/question_bank_2024/detailedStatstotalCount', data).then(
      resp => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({
            totalQuestions: resp.totalQuestions,
          });
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
  }

  async componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var dataChapter = {
      token: storage_session['token'],
      chapterId: this.state.selectedChapter,
    };

    var final_exam = [];
    var user_data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ subscriptionstatus: 'free' });
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });

          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await PartnerCfa1SubscriptionCheck.checkCfa1Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected == '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.setState({ subscriptionstatus: 'free' });
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = Cfa1SubscriptionCheck.checkCfa1Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );

                // console.log("isInArray_var",isInArray_var);

                if (isInArray_var) {
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      chapter: this.state.selectedChapter,
      reading: this.state.selectedReading,
      question: this.state.selectedQuestion,
      selectedAnswered: this.state.selectedAnswered,
      selectedAttempts: this.state.selectedAttempts,
      selectedAvgScore: this.state.selectedAvgScore,
      selectedLowerLimit: this.state.selectedLowerLimit,
      selectedUpperLimit: this.state.selectedUpperLimit,
      selectedUpperLimit: this.state.selectedPassingScore,
      questionLowerLimit: this.state.questionLowerLimit,
      questionUpperLimit: this.state.questionUpperLimit,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    // console.log(data)
    await GetData.callAPI(
      App_data.backend_api + '/exams/cfa/question-bank/chapter-wise-count',
      data,
    ).then(async resp => {
      if (resp.success) {
        console.log('chapter', resp);
        this.setState({ chapters: resp.data });
      } else {
        this.setState({ ValidToken: false });
      }
    });

    await FD.callAPI(App_data.backend_api + '/question_bank_2024/getQuestionsCount', data).then(
      async resp => {
        if (resp.success) {
          this.setState({
            totalQuestions: resp.totalQuestions,
          });
        }
      },
    );

    {
      // Only fetch readings when a chapter is actually selected. This guarded on
      // `this.state.chapter`, which is not a state field (the field is `selectedChapter`),
      // so it was always undefined !== '' → true → fired /question-bank/reading with an
      // empty chapterId on every mount → "Chapter Id not found". Readings are loaded on
      // demand by setSelectedChapter when the user picks a chapter.
      this.state.selectedChapter !== ''
        ? await GetData.callAPI(
            App_data.backend_api + '/exams/cfa/question-bank/reading',
            dataChapter,
          ).then(async resp => {
            if (resp.success) {
              // console.log(resp)
              this.setState({ ValidToken: true });
              this.setState({ readings: resp.readings }, () => {});
            } else {
              this.setState({ ValidToken: false });
            }
          })
        : null;
    }
  }

  render() {
    const {
      readings,
      allQuestion,
      chapters,
      selectedChapter,
      selectedReading,
      selectedQuestion,
      selectedAnswered,
      selectedAttempts,
      selectedAvgScore,
      selectedPassingScore,
      selectedLowerLimit,
      selectedUpperLimit,
      questionLowerLimit,
      questionUpperLimit,
      totalQuestions,
      pageLimit,
      pageNeighbours,
      currentPage,
      loader,
      subscriptionstatus,
      selectedmenu,
      searchBy,
    } = this.state;

    return (
      <div className=''>
        <div className='top-heading-filter-toggle clrearfix '>
          <h4 className='all-question-heading'>
            {' '}
            {language.LC().List_of_All_Questions_For} CFA Level 1{' '}
          </h4>
          <CommonFilter
            onChangeQuestion={this.setSelectedQuestion.bind(this)}
            onChangeChapter={this.setSelectedChapter.bind(this)}
            onChangeReading={this.setSelectedReading.bind(this)}
            onChangeAnswered={this.setSelectedAnswered.bind(this)}
            onChangeNoOfAttempts={this.setSelectedNoOfAttempts.bind(this)}
            onChangeAvgScore={this.setSelectedChangeAvgScores.bind(this)}
            onChangePass={this.setSelectedChangePass.bind(this)}
            onChangePagination={this.setSelectedPagination.bind(this)}
            readingData={readings}
            chapterData={chapters}
            filerSubmit={this._filerQuestionsByChapter.bind(this)}
            resetAllQuestion={this.resetAllQuestion.bind(this)}
            resetAllChapter={this.resetAllChapter.bind(this)}
            selectedChapter={selectedChapter}
            selectedAnswered={selectedAnswered}
            selectedReading={selectedReading}
            selectedQuestion={selectedQuestion}
            selectedAttempts={selectedAttempts}
            selectedAvgScore={selectedAvgScore}
            selectedPassingScore={selectedPassingScore}
            selectedLowerLimit={selectedLowerLimit}
            selectedUpperLimit={selectedUpperLimit}
            subscriptionstatus={subscriptionstatus}
            selectedmenu={selectedmenu}
            searchBy={searchBy}
          />
        </div>
        <CommonDetailStatus
          onChangePagination={this.setSelectedPagination.bind(this)}
          allQuestionData={allQuestion}
          totalQuestions={totalQuestions}
          currentPage={currentPage}
          pageLimit={pageLimit}
          pageNeighbours={pageNeighbours}
          questionLowerLimit={questionLowerLimit}
          questionUpperLimit={questionUpperLimit}
          loader={loader}
          subscriptionstatus={subscriptionstatus}
          selectedmenu={'cfa_2025'}
        />
        {/* <ScrollUpButton
                  StopPosition={0}
                  ShowAtPosition={150}
                  EasingType="easeOutCubic"
                  AnimationDuration={500}
                  ContainerClassName="ScrollUpButton__Container"
                  TransitionClassName="ScrollUpButton__Toggled"
                  style={{}}
                  ToggledStyle={{}}
                /> */}
      </div>
    );
  }
}

export default ViewAllQues2025;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Dashboard/ViewAllQues.js